import { Flex, VStack } from "@chakra-ui/react";
import { TaskTemplate } from "features/Resources/TaskTemplate/models";
import { ShowTrigger } from "features/Resources/Shared/Components/Fields/TriggerField";
import { ShowPrebuiltPaths } from "features/Resources/Shared/Components/Fields/PathsField";
import { ShowName } from "features/Resources/Shared/Components/Fields/NameField";
import { ActionTypeTag } from "design-system";
import { ShowRichText } from "components/FormElements/Fields/RichTextAreaField";
import { ShowRecordTarget } from "features/Resources/Shared/Components/Fields/RecordTargetField";
import { ShowPrebuiltTemplateTaskAction } from "../Fields/TemplateTaskActionField";

export default function PrebuiltTaskTemplateDisplay({ prebuiltTaskTemplate }: { prebuiltTaskTemplate: TaskTemplate }) {
  return (
    <VStack spacing={4} align="stretch" width="100%">
      <Flex w="100%" justify="space-between" align="center" height="40px">
        <ShowName name={prebuiltTaskTemplate?.name} />
        <ActionTypeTag.Badge actionType="task" />
      </Flex>
      <ShowPrebuiltPaths prebuiltPathIds={prebuiltTaskTemplate?.pathIds} />
      <ShowRecordTarget recordTarget={prebuiltTaskTemplate?.assignee} label="Assignee" />
      <ShowTrigger label="Start" trigger={prebuiltTaskTemplate?.startAtTrigger} />
      <ShowTrigger label="Due" trigger={prebuiltTaskTemplate?.dueAtTrigger} />
      <ShowPrebuiltTemplateTaskAction prebuiltTaskTemplate={prebuiltTaskTemplate} />
      <ShowRichText
        label="Description"
        richText={prebuiltTaskTemplate.descriptionDisplay ?? prebuiltTaskTemplate.description}
      />
    </VStack>
  );
}
